<div class="faq-container" *transloco="let t; read: 'faq'">
  <h2>Frequently asked questions</h2>

  @for (config of triggerConfigs(); track config.expandText; let i = $index) {
    <accredible-expansion-panel [triggerConfig]="config">
      <div expansionPanelHeader>
        {{ t('answers.a' + (i + 1)) }}
      </div>
    </accredible-expansion-panel>
  }
</div>
